<template>
    <svg
        class="w-6 h-6"
        fill="none"
        stroke-width="2"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
    >
        <defs>
            <clipPath id="topHalf">
                <rect x="0" y="0" width="24" height="12"/>
            </clipPath>
            <clipPath id="bottomHalf">
                <rect x="0" y="12" width="24" height="12"/>
            </clipPath>
        </defs>
        <!-- Green top half -->
        <circle
            cx="12"
            cy="12"
            r="8"
            fill="#10b981"
            clip-path="url(#topHalf)"
        />
        <!-- Orange bottom half -->
        <circle
            cx="12"
            cy="12"
            r="8"
            fill="#ffa500"
            clip-path="url(#bottomHalf)"
        />
        <!-- Stroke around the whole circle -->
        <circle
            cx="12"
            cy="12"
            r="8"
            fill="none"
            stroke="#059669"
            stroke-width="2"
        />
    </svg>
</template>
